export const NOT_QUALIFIED = "Purchase not Qualified for Coupon Discount"
export const QUALIFIED = "Purchase Qualified for Coupon Discount"